import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'wireToInfoWarehouseBankId',
    label: 'Warehouse Bank',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'wireNumber',
    label: 'Wire Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'fedReferenceNumber',
    label: 'Fed Reference Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'wireToInfoWireAmount',
    label: 'Wire Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'advanceAmount',
    label: 'Advance Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'addAdvanceAmount',
    label: 'Add Advance Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const wireToInformationForm = {
  name: FormNames.FUNDING_INFORMATION,
  label: 'Wire To Information',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
